/**
 * Log currently focused element to console.
 */
export function logFocus() {
	const queryString = window.location.search;
	const urlParams = new window.URLSearchParams( queryString );

	if ( urlParams.get( 'logfocus' ) == 'true' ) {
		document.addEventListener( 'focusin', function() {
			console.log( 'focused: ', document.activeElement )
		}, true );
	}
}
